export default __webpack_public_path__ + "static/media/handposition.5c9605c7.png";